0
import useAuth from "@/hooks/useAuth";

const useUploaderConfig = (type) => {
  const { user } = useAuth();

  const clientId = user?.client_id;
  const restaurantId = user?.restaurant_id;

  const directory = `restaurant/${restaurantId}/${type}/image`;

  return {
    clientId,
    restaurantId,
    directory,
  };
};

export default useUploaderConfig;
